import apiHandler from "../core/apiHandler";

const enabledDocumentTypesApi = apiHandler("dte/enabled-document-types");
export default enabledDocumentTypesApi;
